/**
 * 判斷指定西元年是否為閏年。
 *
 * @param {number|string} year 西元年
 * @returns {boolean} 是閏年時回傳 true，否則回傳 false
 */
export default function isLeapYear(year) {
  const normalizedYear = Number(year);

  if (!Number.isInteger(normalizedYear)) return false;

  return (
    normalizedYear % 400 === 0 ||
    (normalizedYear % 4 === 0 && normalizedYear % 100 !== 0)
  );
}
